import { Component, input, computed } from '@angular/core';

@Component({
  selector: 'app-progress-bar',
  styleUrl: './progress-bar.component.scss',
  template: `
    <p-progressBar
      [value]="displayValue()"
      [showValue]="showValue()"
      [unit]="unit()"
      [style]="{ width: width(), height: height() }"
      [color]="calculatedColor()"
      [class]="customClass()"
    ></p-progressBar>
  `,
})
export class ProgressBarComponent {
  value = input.required<number>();
  showValue = input<boolean>(false);
  unit = input<string>('%');
  width = input<string>('100%');
  height = input<string>('8px');
  color = input<string | undefined>(undefined);
  customClass = input<string>('');

  maxDays = input<number>(30);
  reverseMode = input<boolean>(false);

  calculatedColor = computed(() => {
    if (this.color()) return this.color();

    const currentValue = this.value();
    const percentage = (currentValue / this.maxDays()) * 100;

    if (this.reverseMode()) {
      if (percentage <= 33) return 'var(--p-success-400)';
      if (percentage <= 66) return 'var(--p-warning-400)';
      return 'var(--p-error-400)';
    } else {
      if (percentage <= 33) return 'var(--p-error-400)';
      if (percentage <= 66) return 'var(--p-warning-400)';
      return 'var(--p-success-400)';
    }
  });

  displayValue = computed(() => {
    if (this.reverseMode()) {
      return 100 - (this.value() / this.maxDays()) * 100;
    }
    return (this.value() / this.maxDays()) * 100;
  });
}
